import React from 'react';
import cx from 'classnames';
import TitleComponent from "../Title/Title";
var css = {
  "separator": "oalp-1lreM",
  "section": "oalp-5x4cy",
  "mobile": "oalp-1OuzZ"
};
import DependencyManager from "../../DependencyManager";
import ImageWrapper from "../ImageWrapper/ImageWrapper";
export var SectionComponent = function SectionComponent(_ref) {
  var name = _ref.name,
    metadata = _ref.metadata,
    children = _ref.children,
    title = _ref.title,
    subtitle = _ref.subtitle;
  var PanameraConstants = DependencyManager.getDependency('constants');
  var _ref2 = metadata || {},
    alignment = _ref2.alignment,
    separator = _ref2.separator,
    sectionStyle = _ref2.style,
    image = _ref2.image;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    id: name,
    style: sectionStyle,
    className: cx(css.section, css[PanameraConstants.platform], {
      'vertical-section': alignment === 'vertical',
      'horizontal-section': alignment !== 'vertical'
    })
  }, image && /*#__PURE__*/React.createElement(ImageWrapper, {
    image: image
  }), title && /*#__PURE__*/React.createElement(TitleComponent, {
    title: title
  }), subtitle && /*#__PURE__*/React.createElement(TitleComponent, {
    title: subtitle
  }), children), !!separator && /*#__PURE__*/React.createElement("div", {
    className: css.separator
  }));
};
export default SectionComponent;